// extracted by mini-css-extract-plugin
export var measureBox = "_az-0";